import { Component, OnInit, } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceConceptTableModel } from 'src/app/models/tables/invoicing/invoice-concept-table.model';
import { InvoiceDetailTableModel } from 'src/app/models/tables/invoicing/invoice-detail-table.model';
import { InvoiceTableModel } from 'src/app/models/tables/invoicing/invoice-table.model';
import { HeaderService } from 'src/app/services/header/header.service';
import { ChargeAccountConceptService } from 'src/app/services/others/charge-account-concept.service';
import { ChargeAccountDetailService } from 'src/app/services/others/charge-account-detail.service';
import { ChargeAccountService } from 'src/app/services/others/charge-account.service';
@Component({
  selector: 'app-charge-account',
  templateUrl: './charge-account.component.html',
  styleUrls: ['./charge-account.component.scss'],
  standalone: false
})
export class ChargeAccountComponent implements OnInit {

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  conceptData: PagedResponseModel<InvoiceConceptTableModel> = new PagedResponseModel<InvoiceConceptTableModel>();
  conceptHeader: FilterGlobalResponseModel = new FilterGlobalResponseModel();
  detailData: PagedResponseModel<InvoiceDetailTableModel> = new PagedResponseModel<InvoiceDetailTableModel>();
  detailHeader: FilterGlobalResponseModel = new FilterGlobalResponseModel();
  filters: ColumnResponseModel[] = []
  generalData: PagedResponseModel<InvoiceTableModel> = new PagedResponseModel<InvoiceTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  limit: number = 10;
  listStoreConsolidated: ColumnResponseModel = new ColumnResponseModel();
  nameWindow: string = 'Cuentas de Cobro';
  page: number = 1;
  previousSort: { field: string; isAscsendant: number };
  projectName = ProjectName.projectName;
  storeConsolidated: boolean = true;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = 'charge-account';

  constructor(private chargeAccountService: ChargeAccountService,
    private chargeAccountConceptService: ChargeAccountConceptService,
    private chargeAccountDetailService: ChargeAccountDetailService,
    private router: Router,
    private headerService: HeaderService,
    private title: Title) {
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);

    await this.getColumnsForGeneralConsultation();
    this.setDefaultFilters();
    await this.getChargeAccountsWithPagination();
  }

  async exportConceptConsultation() {
    try {
      const response = await firstValueFrom(
        this.chargeAccountConceptService.exportConceptConsultation(
          this.filters, this.columnSort, this.ascendant, this.storeConsolidated
        )
      );
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Cuentas Concepto.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error al exportar las cuentas concepto.', error);
    }
  }

  async exportDetailConsultation() {
    try {
      const response = await firstValueFrom(
        this.chargeAccountDetailService.exportDetailConsultation(
          this.filters, this.columnSort, this.ascendant, this.storeConsolidated
        )
      );
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Cuentas Detalle.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error al exportar las cuentas detalle.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const response = await firstValueFrom(
        this.chargeAccountService.exportGeneralConsultation(
          this.filters, this.columnSort, this.ascendant)
      );
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Cuentas de cobro.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error al exportar las cuentas.', error);
    }
  }

  async getAllChargeAccountConceptsWithPagination() {
    try {
      this.conceptData = await firstValueFrom(
        this.chargeAccountConceptService.getAllChargeAccountConceptsWithPagination(
          this.page, this.limit, this.columnSort, this.ascendant, this.storeConsolidated, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar los conceptos de las facturas.', error);
    }
  }

  async getAllChargeAccountDetailsWithPagination() {
    try {
      this.detailData = await firstValueFrom(
        this.chargeAccountDetailService.getAllChargeAccountDetailsWithPagination(
          this.page, this.limit, this.columnSort, this.ascendant, this.storeConsolidated, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar los detalles de las facturas.', error);
    }
  }

  async getChargeAccountsWithPagination() {
    try {
      this.generalData = await firstValueFrom(
        this.chargeAccountService.getChargeAccountsWithPagination(
          this.page, this.limit, this.columnSort, this.ascendant, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar las facturas.', error);
    }
  }

  async getColumnsForConceptConsultation() {
    try {
      if (this.conceptHeader.columns.length === 0) {
        this.conceptHeader = await firstValueFrom(this.chargeAccountConceptService.getColumnsForConceptConsultation());
      }
      this.listStoreConsolidated = this.conceptHeader.filtersGlobal[0];
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getColumnsForDetailConsultation() {
    try {
      if (this.detailHeader.columns.length === 0) {
        this.detailHeader = await firstValueFrom(this.chargeAccountDetailService.getColumnsForDetailConsultation());
      }
      this.listStoreConsolidated = this.detailHeader.filtersGlobal[0];
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(this.chargeAccountService.getColumnsForGeneralConsultation());
      }
      this.listStoreConsolidated = new ColumnResponseModel;
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  public async handleTabChange(tabIndex: number) {
    this.generalHeader.length = this.generalHeader.length === 1 ? 0 : this.generalHeader.length;
    this.detailHeader.columns.length = this.detailHeader.columns.length === 1 ? 0 : this.detailHeader.columns.length;
    this.conceptHeader.columns.length = this.conceptHeader.columns.length === 1 ? 0 : this.conceptHeader.columns.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultation(),
          this.getChargeAccountsWithPagination()
        ]);
        this.generalData = {
          ...this.generalData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForDetailConsultation(),
          this.getAllChargeAccountDetailsWithPagination()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 2:
        await Promise.all([
          this.getColumnsForConceptConsultation(),
          this.getAllChargeAccountConceptsWithPagination()
        ]);
        this.conceptData = {
          ...this.conceptData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  newInvoice() {
    this.router.navigate([`/${this.url}/register`]);
  }

  onAction(event: { action: string, item?: InvoiceTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/${this.url}/register/${event.item.invoiceId}`]);
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultation();
        break;
      case 1:
        await this.exportDetailConsultation();
        break;
      case 2:
        await this.exportConceptConsultation();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }


  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getChargeAccountsWithPagination()
        break;
      case 1:
        await this.getAllChargeAccountDetailsWithPagination()
        break;
      case 2:
        await this.getAllChargeAccountConceptsWithPagination()
        break;
    }
  }

  onStoreConsolidatedChange(value: boolean) {
    this.storeConsolidated = value;
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  setDefaultFilters() {
    const defaultFilters = this.generalHeader.filter(x => x.isFilter && x.valueFilter);
    const hasDefaultFilterValue = this.filters.some(f =>
      defaultFilters.some(d => d.propertyName === f.propertyName) && f.valueFilter
    );
    if (!hasDefaultFilterValue) {
      this.filters = [
        ...this.filters.filter(f => !defaultFilters.some(d => d.propertyName === f.propertyName)),
        ...defaultFilters.map(x => ({
          propertyName: x.propertyName,
          valueFilter: x.valueFilter
        }) as ColumnResponseModel),
      ];
    }
  }
}
